import React, { Component } from 'react';
import cx from 'classnames';
import FiltersGroupContainer from './FiltersGroupContainer';
import Dropdown from '../../Dropdown';
import Icon from '../../Icon';
import DropdownFiltersGroupSelectedItem from './DropdownFiltersGroupSelectedItem';
import '../styles/_dropdownFilters.scss';





































export default class DropdownFiltersGroup extends
Component {
  static defaultProps = {
    selectedValues: [],
    filterFacets: [],
    isSingleSelect: false
  };

  constructor(props) {
    super(props);

    const initialSelectedValues = props.filterFacets ?
    props.filterFacets.filter((filter) => props.selectedValues.includes(filter.value)) :
    [];

    this.state = {
      selectedItems: initialSelectedValues,
      selectedValue: props.isSingleSelect ? initialSelectedValues[0] : null
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedValues } = this.props;

    if (prevProps.selectedValues.length !== selectedValues.length && !selectedValues.length) {
      this.resetFilter();
    }
  }

  resetFilter = () => {
    this.setState({
      selectedItems: [],
      selectedValue: null
    });
  };

  handleFilterChange = (option) => {
    const { onChange, isSingleSelect } = this.props;
    const { selectedItems } = this.state;

    if (option && !selectedItems.find((item) => item.value === option.value)) {
      selectedItems.push(option);
    }

    if (!isSingleSelect) {
      this.setState({
        selectedItems,
        selectedValue: option
      });

      return onChange(selectedItems);
    }

    const newSelectedItems = [option].filter(Boolean);

    this.setState({
      selectedItems: newSelectedItems,
      selectedValue: option
    });

    return onChange(newSelectedItems);
  };

  onDeleteSelectedItem = (value) => {
    const { onChange } = this.props;
    const { selectedItems } = this.state;

    const updatedValues = selectedItems.filter((item) => item.value !== value);

    this.setState({
      selectedItems: updatedValues
    });
    return onChange(updatedValues);
  };

  render() {
    const { filterFacets,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      isSearchable = true,
      isClearable = true,
      isSingleSelect,
      placeholder,
      customPrefix,
      name,
      disabled,
      minWidth,
      loadOptions,
      searchPromptText,
      noResultsText
    } = this.props;

    const { selectedItems, selectedValue } = this.state;

    const decoratorToRender = typeof customPrefix === 'string' ?
    <Icon color="nevada" name={customPrefix} size={15} /> :
    customPrefix;

    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        <div className={cx('dropdown-filter__wrapper', { 'dropdown-filter__wrapper-decorator': !!customPrefix })}>
          {decoratorToRender || ''}
          <Dropdown
            id={name}
            // $FlowFixMe
            options={filterFacets}
            type="BUTTON"
            isSearchable={isSearchable}
            isClearable={isClearable}
            placeholder={placeholder}
            onChange={this.handleFilterChange}
            disabled={disabled}
            // $FlowFixMe
            value={selectedValue}
            renderMenuLocally
            cutLongLabels
            loadOptions={loadOptions}
            searchPromptText={searchPromptText}
            noResultsText={noResultsText} />

          <div className="dropdown-selected-items">
            {
            !isSingleSelect && selectedItems.map((item) =>
            <DropdownFiltersGroupSelectedItem
              key={item.value}
              value={item.value}
              // $FlowFixMe
              label={item.label}
              icon={item.icon}
              iconColour={item.iconColour}
              iconBackground={item.iconBackground}
              imageUrl={item.imageUrl}
              placeholder={item.placeholder}
              circular={item.circular}
              onDelete={this.onDeleteSelectedItem} />

            )}

          </div>
        </div>
      </FiltersGroupContainer>);

  }
}